var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['simple-widget', _vm.widgetClass]},[(_vm.hasTitle)?_vm._t("title"):_vm._e(),_vm._v(" "),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }